import {
  SET_GENERAL_DATA,
  IS_LOADING,
  TOGGLE_NAV_DRAWER,
  SHOW_APP_BAR,
  SHOW_ALERT_DIALOG,
  SHOW_CONFIRM_DIALOG,
  SET_ALERT_DIALOG_CONTENT,
  SET_CONFIRM_DIALOG_DATA,
  SET_BANK_LIST,
  SET_ROLE, GET_ANNOUNCEMENTS, GET_QUIZ, GET_NOTE, GET_TIMETABLE
} from "../types";

export const generalStates = {
  showAlertDialog: false,
  showConfirmDialog: false,
  alertDialog : {
    title: "Oops",
    content: ""
  },
  confirmDialog : {
    title: "Oops",
    content: "",
    dateSelection: false,
  },
  confirmDialogAction: null,
  isLoading: false,
  showNavDrawer: sessionStorage.getItem("userToken")? true : false,
  showAppBar: sessionStorage.getItem("userToken")? true : false,
  teachers: [],
  students: [],
  newEnrolmentStudents: [],
  tuitionFees: [],
  misc: [],
  student: {},
  teacher: {},
  teachersSalary: [],
  banks: [],
  classroom: [],
  announcements: [],
  quiz: [],
  notes: [],
  timetables: [],
  role: "EMPLOYEE"
};

export const generalReducer = (state, action) => {
  switch (action.type) {
    case SET_GENERAL_DATA:
      return {
        ...state,
        ...action.data
      };
    case IS_LOADING:
      return {
        ...state,
        isLoading: action.data,
      };
    case SET_ALERT_DIALOG_CONTENT:
      return {
        ...state,
        alertDialog : { title: action.title, content: action.content},
        showAlertDialog: true
      };
    case SHOW_ALERT_DIALOG:
      return {
        ...state,
        showAlertDialog: action.data,
      };
    case SET_CONFIRM_DIALOG_DATA:
      return {
        ...state,
        showConfirmDialog: action.showConfirmDialog,
        confirmDialog : {
          title: action.title,
          content: action.content,
          dateSelection: action.dateSelection,
        },
        confirmDialogAction : action.confirmDialogAction
      };
    case SHOW_CONFIRM_DIALOG:
      return {
        ...state,
        showConfirmDialog: action.data,
      };
    case TOGGLE_NAV_DRAWER:
      return {
        ...state,
        showNavDrawer: action.data,
      };
    case SHOW_APP_BAR:
      return {
        ...state,
        showAppBar: action.data,
      };
    case SET_BANK_LIST:
      return {
        ...state,
        banks: action.data,
      };
    case SET_ROLE:
      return {
        ...state,
        role: action.role,
      };

    case GET_ANNOUNCEMENTS:
      return {
        ...state,
        announcements: action.data.announcements
      }
    case GET_QUIZ:
      return {
        ...state,
        quiz: action.data.quiz
      }
    case GET_NOTE:
      return {
        ...state,
        notes: action.data.notes
      }
    case GET_TIMETABLE:
      return {
        ...state,
        timetables: action.data.timetables
      }
    default: return state
  }
};
